import {makeStyles} from "@material-ui/styles"

const useStyles = makeStyles(theme => ({
  tokenSelection: {
    width: "100%",
  },
  buttonNotLast: {
    marginRight: theme.spacing(1),
  },
  buttonWrapper: {
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: theme.spacing(2),
  },
}))

export default useStyles
